import { Html } from '@react-three/drei';
import type { MeasurementSceneBadge } from './viewerMeasurements';

interface MeasurementSceneBadgesProps {
  badges: MeasurementSceneBadge[];
}

export function MeasurementSceneBadges({ badges }: MeasurementSceneBadgesProps) {
  return (
    <>
      {badges.map((badge) => (
        <Html
          key={badge.id}
          position={badge.position}
          center
          transform={false}
          pointerEvents="none"
        >
          <div className="viewer-measure-badge">{badge.label}</div>
        </Html>
      ))}
    </>
  );
}
